import { createSlice, createAsyncThunk, createNextState } from '@reduxjs/toolkit'
import { Gateway } from '../../types/gateway.interface'
import { submitCcpaMutation } from '../../graphql'
import { Payload } from '../../types'
import { initialState } from './initialState'

export const submitCcpaThunk: any = createAsyncThunk('gateway/submitCcpa', async (payload: Payload) => await submitCcpaMutation(payload))

export const submitCcpaPending = (state: Gateway): Gateway =>
  createNextState(state, (draftState) => {
    draftState.submitting = true
  })

export const submitCcpaFulfilled = (state: Gateway): Gateway =>
  createNextState(state, (draftState) => {
    draftState.submitting = false
  })

export const submitCcpaRejected = (state: Gateway, action: { error: Error }): Gateway =>
  createNextState(state, (draftState) => {
    draftState.submitting = false
    draftState.error = action.error
  })

export const clearGatewayStateError = (state: Gateway): Gateway =>
  createNextState(state, (draftState) => {
    draftState.error = null
  })

export const gatewaySlice = createSlice({
  name: 'gateway',
  initialState,
  reducers: {
    clearGatewayError: (state) => clearGatewayStateError(state)
  },
  extraReducers: {
    [submitCcpaThunk.pending]: submitCcpaPending,
    [submitCcpaThunk.fulfilled]: submitCcpaFulfilled,
    [submitCcpaThunk.rejected]: submitCcpaRejected,
  }
})

export const { clearGatewayError } = gatewaySlice.actions
export default gatewaySlice.reducer
